<script setup>
import { Button } from '@/components/ui/button'

defineProps({
  datasets: { type: Array, required: true },
  visibility: { type: Map, required: true },
})

const emit = defineEmits(['toggle'])
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <Button
      v-for="dataset in datasets"
      :key="dataset.label"
      size="sm"
      variant="ghost"
      class="py-0.5 px-1 h-auto"
      :class="[
        visibility.get(dataset.label) !== false
          ? 'border-border bg-background'
          : 'border-border bg-muted opacity-60'
      ]"
      @click="emit('toggle', dataset.label)"
    >
      <div
        class="w-2.5 h-2.5 rounded-full mr-1 flex-shrink-0"
        :style="{ backgroundColor: dataset.backgroundColor }"
      />
      <span class="truncate">{{ dataset.displayName || dataset.label }}</span>
    </Button>
  </div>
</template>
